<ng-container *ngFor="let item of historyItems">
  <ng-container *ngTemplateOutlet="item.content"></ng-container>
</ng-container>
